// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ultimate-security-settings-template .single-select {
  position: relative;
  width: 100%;
  font-family: inherit;
}
.ultimate-security-settings-template .single-select .select-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid rgba(60, 67, 74, 0.5019607843);
  background-color: transparent;
  padding: 7px 10px;
  border-radius: 3px;
  color: #3c434a;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0%;
  width: 100%;
  max-width: 375px;
}
.ultimate-security-settings-template .single-select .select-button:hover {
  border-color: #aaa;
}
.ultimate-security-settings-template .single-select .select-button:focus {
  outline: none;
  border: 1px solid rgba(60, 67, 74, 0.5019607843);
  box-shadow: unset;
}
.ultimate-security-settings-template .single-select .select-button .placeholder {
  color: #999;
}
.ultimate-security-settings-template .single-select .select-button .chevron {
  font-size: 10px;
  color: #666;
}
.ultimate-security-settings-template .single-select .options-container {
  position: absolute;
  z-index: 100;
  top: calc(100% + 5px);
  left: 0;
  width: 100%;
  max-width: 375px;
  max-height: 210px;
  overflow-y: auto;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  color: #3c434a;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0%;
}
.ultimate-security-settings-template .single-select .options-container .option {
  padding: 10px 15px;
  cursor: pointer;
}
.ultimate-security-settings-template .single-select .options-container .option:hover {
  background-color: #f5f5f5;
}
.ultimate-security-settings-template .single-select .options-container .option.selected {
  background-color: #40bfb4;
  color: #000;
}
.ultimate-security-settings-template .single-select .options-container .no-options {
  padding: 10px 15px;
  color: #999;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/components/SingleSelect/SingleSelect.scss"],"names":[],"mappings":"AACC;EACC,kBAAA;EACA,WAAA;EACA,oBAAA;AAAF;AAEE;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AAAH;AAEG;EACC,kBAAA;AAAJ;AAGG;EACC,aAAA;EACA,gDAAA;EACA,iBAAA;AADJ;AAIG;EACC,WAAA;AAFJ;AAKG;EACC,eAAA;EACA,WAAA;AAHJ;AAOE;EACC,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACK,sBAAA;EACL,kBAAA;EACK,cAAA;EACL,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AALH;AAOG;EACC,kBAAA;EACA,eAAA;AALJ;AAOI;EACC,yBAAA;AALL;AAQI;EACC,yBAAA;EACA,WAAA;AANL;AAUG;EACC,kBAAA;EACA,WAAA;EACA,kBAAA;AARJ","sourcesContent":[".ultimate-security-settings-template {\n\t.single-select {\n\t\tposition: relative;\n\t\twidth: 100%;\n\t\tfont-family: inherit;\n\n\t\t.select-button {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: space-between;\n\t\t\tborder: 1px solid rgba(60, 67, 74, 0.5019607843);\n\t\t\tbackground-color: transparent;\n\t\t\tpadding: 7px 10px;\n\t\t\tborder-radius: 3px;\n\t\t\tcolor: #3c434a;\n\t\t\tfont-weight: 400;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 22px;\n\t\t\tletter-spacing: 0%;\n\t\t\twidth: 100%;\n\t\t\tmax-width: 375px;\n\n\t\t\t&:hover {\n\t\t\t\tborder-color: #aaa;\n\t\t\t}\n\n\t\t\t&:focus {\n\t\t\t\toutline: none;\n\t\t\t\tborder: 1px solid rgba(60, 67, 74, 0.5019607843);\n\t\t\t\tbox-shadow: unset;\n\t\t\t}\n\n\t\t\t.placeholder {\n\t\t\t\tcolor: #999;\n\t\t\t}\n\n\t\t\t.chevron {\n\t\t\t\tfont-size: 10px;\n\t\t\t\tcolor: #666;\n\t\t\t}\n\t\t}\n\n\t\t.options-container {\n\t\t\tposition: absolute;\n\t\t\tz-index: 100;\n\t\t\ttop: calc(100% + 5px);\n\t\t\tleft: 0;\n\t\t\twidth: 100%;\n\t\t\tmax-width: 375px;\n\t\t\tmax-height: 210px;\n\t\t\toverflow-y: auto;\n\t\t\tbackground-color: #fff;\n      \t\tborder: 1px solid #ddd;\n\t\t\tborder-radius: 4px;\n      \t\tcolor: #3c434a;\n\t\t\tfont-weight: 400;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 22px;\n\t\t\tletter-spacing: 0%;\n\n\t\t\t.option {\n\t\t\t\tpadding: 10px 15px;\n\t\t\t\tcursor: pointer;\n\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground-color: #f5f5f5;\n\t\t\t\t}\n\n\t\t\t\t&.selected {\n\t\t\t\t\tbackground-color: #40bfb4;\n\t\t\t\t\tcolor: #000;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.no-options {\n\t\t\t\tpadding: 10px 15px;\n\t\t\t\tcolor: #999;\n\t\t\t\tfont-style: italic;\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
